<template>
    <div class="row start-xs" v-if="initLoading">
        <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer" >
        <SearchResultListingCard :property="property" :loading="fullscreenLoading"/>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer" >
        <SearchResultListingCard :property="property" :loading="fullscreenLoading"/>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer" >
        <SearchResultListingCard :property="property" :loading="fullscreenLoading"/>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer" >
        <SearchResultListingCard :property="property" :loading="fullscreenLoading"/>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer" >
        <SearchResultListingCard :property="property" :loading="fullscreenLoading"/>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer" >
        <SearchResultListingCard :property="property" :loading="fullscreenLoading"/>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer" >
        <SearchResultListingCard :property="property" :loading="fullscreenLoading"/>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer" >
        <SearchResultListingCard :property="property" :loading="fullscreenLoading"/>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer" >
        <SearchResultListingCard :property="property" :loading="fullscreenLoading"/>
        </div>
    </div>
</template>

<script>
        import SearchResultListingCard from '../SearchResults/SearchResultListingCard'

        export default {
        name:'listing-content-loader',

        data:function() {
                return {
                property: {}
                }
        },
        components: {
                SearchResultListingCard
        },
        props:{
                initLoading: Boolean,
                fullscreenLoading: Boolean
        }
        }
</script>

<style lang="scss" scoped>

</style>
